import {Injectable} from '@angular/core';
import Messages_de from './i18n_messages_de.json';
import Messages_en from './i18n_messages_en.json';
import {DateUtilsBs} from "./dateUtilsBs";
import { I18NTextEntity, Language } from '../../model/dto.models.imported';

@Injectable({
    providedIn: 'root'
})
export class I18NService {
    locale: string;
    lang: string;

    private TAG_LANG = "i18n.selectedLang";
    static DEFAULT_LOCALE : string = "de-DE";


    constructor() {
        console.log("[I18NService] instance created !");
        this.locale = this.detectUsersLocale();
        this.lang  = this.locale.substring(0, 2);
        console.log("DETECTED LOCALE: " + this.locale);
    }

    /**
     * Translates.
     */
    public v(aKey: string): string {
        //console.log("[i18n|" + this.locale + "] " + aKey);
        var pTranslated;
        if (this.locale != null && this.locale.startsWith("en")) {
            pTranslated = Messages_en[aKey];
        } else {
            pTranslated = Messages_de[aKey];
        }

        // multiline support:
        if (Array.isArray(pTranslated)) {
            var pTranslatedML = "";
            for (var pLine of pTranslated) {
                pTranslatedML += pLine;
            }
            pTranslated = pTranslatedML;
        }

        return pTranslated ? pTranslated : "_" + aKey + "_";
    }

    /**
     * Gets browser locale
     */
    private detectUsersLocale(): string {

        // from Session
        var pSessionLANG = sessionStorage.getItem(this.TAG_LANG);
        if (pSessionLANG) {
            return pSessionLANG;
        }

        // from Window.navigator
        if (typeof window === 'undefined' || typeof window.navigator === 'undefined') {
            return I18NService.DEFAULT_LOCALE;
        }
        let pNavigator = window.navigator;
        let pBrowserLANG = pNavigator.languages ? pNavigator.languages[0] : (pNavigator.language);
        if (pBrowserLANG.includes("de-") || pBrowserLANG.includes("en-")) {
            return pBrowserLANG
        }

        // fallback
        return I18NService.DEFAULT_LOCALE;

    }

    /**
     * Changes.
     * @param aLocale
     */
    public changeLang(aLocale: string) {
        console.log("Changing lang to " + aLocale);
        this.locale = aLocale ? aLocale : I18NService.DEFAULT_LOCALE;
        this.lang = this.locale.substring(0,2);
        sessionStorage.setItem(this.TAG_LANG, aLocale);
    }

    /**
     * Formats.
     * @param aDate
     */
    public formatDate(aDate: Date) {
        return DateUtilsBs.formatDate(aDate, this.locale);
    }

    /**
     * Formats.
     * @param aDate
     */
    public formatDayName(aDate: Date) {
        return DateUtilsBs.formatDayName(aDate, this.locale);
    }

    public languageFromUsersLocale() : Language{
        const userLocale = this.detectUsersLocale();
        if (userLocale.includes('de')) return Language.DEUTSCH;
        if (userLocale.includes('en')) return Language.ENGLISH;
        if (userLocale.includes('pl')) return Language.POLISH;

        return Language.ENGLISH;
    }

    public extractTextWithFallBack(texts : { [P in Language]?: I18NTextEntity }) : string | undefined {

        if (!Object.keys(texts).length) return undefined;

        return (texts[this.languageFromUsersLocale()] || texts[Object.keys(texts)[0]]).text;

    }

}
